<template>
  <div class="accountManagement">
    <signboard :signboardName="signboardName"></signboard>
    <!-- 新增成员 -->
    <el-row class="new-customer">
      <el-button v-if="toEditDisabled == false" @click="dialogBox('新增成员')" size="small" type="primary" >新增成员</el-button>
      <span class="peopleCounting">已绑定人数：{{peopleCounting}}人</span>
    </el-row>
    <!-- 表格 -->
    <div class="list">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="序号" type="index" width="" >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名"  width="">
          <template slot-scope="scope">
            <span hidden>{{ scope.row.id }}</span>
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机" width="">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="">
          <template slot-scope="scope">
            <span>{{ scope.row.role }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" width="">
          <template slot-scope="scope">
            <span>{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="" header-align='right'>
          <template slot-scope="scope" >
            <el-button @click="dialogBox('删除',scope.row)" type="text" size="medium" style="float:right" :disabled="toEditDisabled">删除</el-button>
            <span class="vertical-bar" style="float:right">丨</span>
            <el-button @click="dialogBox('资料修改',scope.row)" size="medium" style="float:right"  type="text">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增弹框 -->
    <el-dialog class="fl" :title="functionName" :visible.sync="NewDialogBox" width="34%" top='236px' :close-on-click-modal="false">
      <div class="strong-frame">
        <div class="row">
          <div>姓&nbsp;&nbsp;&nbsp;&nbsp;名：</div>
          <el-input class="input" size="small" v-model="inputName" @change="nameReg()" placeholder="请输入内容" maxlength="10" clearable></el-input>
        </div>
        <div class="row">
          <div>手机号：</div>
          <el-input class="input" size="small" v-model="inputPhone" placeholder="请输入内容" @change="isPhone(inputPhone)" maxlength="11" clearable></el-input>
        </div>
        <div class="row">
          <div>验证码：</div>
          <el-input class="code-input" size="small" maxlength="6" placeholder="" v-model="code"></el-input>
          <el-button class="get-code" :disabled='getCodeStatus' @click="getCode"  size="small" plain>{{getCodeStatus?downCount+'s':downCount}}</el-button>
          <div class="error">{{addErrorMsg}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="canleAdd" size="mini">取 消</el-button>
        <el-button :plain="true" type="primary" @click="newCustomer" size="mini">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog class="pop-up fl" :title="functionName" :visible.sync="EditDialog" width="34%" top='236px' :close-on-click-modal="false">
      <div class="strong-frame">
        <div class="row">
          <div>姓  名：</div>
          <el-input class="input" size="small" v-model="info.name" @change="nameReg()" placeholder="请输入内容" maxlength="10"  clearable></el-input>
        </div>
        <div class="row">
          <div>手机：</div>
          <el-input class="input" size="small" :disabled="this.editPhoneDisabled" v-model="info.phone" @change="isPhone(info.phone)" maxlength="11" clearable></el-input>
          <el-button :disabled="this.toEditDisabled" @click="amend('手机号修改')" class="amend" type="text" >修改</el-button>
        </div>
        <div class="row">
          <div>邮箱：</div>
          <el-input class="input" size="small" :disabled="this.editEmailDisabled"  v-model="info.email" @change="isEmailReg()" maxlength="64" clearable></el-input>
          <el-button :disabled="this.toEditEmailDisabled" @click="amend('邮箱修改')" class="amend" type="text">修改</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit()" size="mini">取 消</el-button>
        <el-button type="primary" @click="editContact" size="mini">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 修改弹框 手机号/邮箱-->
    <el-dialog class="fl"  :title="amendFrameName" :visible.sync="ModifydialogBox" width="34%" top='236px' :close-on-click-modal="false">
      <!-- 手机号修改 -->
      <div class="strong-frame" v-if="amendFrameName=='手机号修改'">
        <div class="row">
          <div>手机号：</div>
          <div>{{info.phone}}</div>
        </div>
        <div class="row">
          <div>验证码：</div>
          <el-input class="code-input" size="small" maxlength="8" placeholder="" v-model="phoneCode"></el-input>
          <el-button class="get-code" :disabled='getCodeStatus' @click="getCode"  size="small" plain>{{getCodeStatus?downCount+'s':downCount}}</el-button>
          <div class="error">{{errorMsg}}</div>
        </div>
      </div>
      <!-- 邮箱修改 -->
      <div class="strong-frame" v-if="amendFrameName=='邮箱修改'">
        <div class="row" >
          <div>邮箱号：</div>
          <div>{{info.email}}</div>
        </div>
        <div class="row">
          <div>验证码：</div>
          <el-input class="code-input" size="small" maxlength="8" placeholder="" v-model="mailboxCode"></el-input>
          <el-button class="get-code" :disabled='getCodeStatus' @click="getCode"  size="small" plain>{{getCodeStatus?downCount+'s':downCount}}</el-button>
          <div class="error">{{errorMsg}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="mini">取 消</el-button>
        <el-button type="primary" @click="verifyVerificationCode()" size="mini">下一步</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import signboard from "@/components/signboard";
  // import API from "../../../api/bill";
  import API from "../../../api/setTing";
  const api = new API();
  export default {
      components:{signboard},
      data() {
          return {
              amendFrameName:'手机号修改',
              ModifydialogBox:false,
              innerVisible: false,
              EditDialog:false,
              getCodeStatus:false,
              downCount:'获取验证码',
              code:'',
              phoneCode:'',
              mailboxCode:'',
              functionName:'',
              inputName:'',
              inputPhone:'',
              NewDialogBox:false,
              peopleCounting:0,
              signboardName:'用户管理',
              timer:{},
              info:{phone:'',email:'',name:''},
              tableData: [],
              errorMsg:"",
              verifyCode:"",
              editPhoneDisabled: true,
              editEmailDisabled: true,
              toEditDisabled: true,
			  toEditEmailDisabled: true,
              toEditNameDisabled:false,
              addErrorMsg: ""
          }
      },
      watch:{ //监听关闭新增弹框关闭弹
          NewDialogBox(n, o){
              console.log(n,o);
              if ( !n ){
                  if(typeof(this.downCount)=='number')return this.clearCimer()
              }
          },
          ModifydialogBox(n, o){ //监听关闭修改弹框 手机号/邮箱
              console.log(n,o);
              if ( !n ){
                  if(typeof(this.downCount)=='number')return this.clearCimer()
              }
          }
      },
      mounted:function () {
          this.init();
          this.initAuthByRole();
      },
      methods: {
          init(){//根据客户编码查询客户名下所有的联系人信息
              this.queryContactByCustomer();
          },
          async queryContactByCustomer(){
      let res = await api.queryContactByCustomer();
      if(res.superAdmin!=null){
          if(res.admin == null){
            res.admin = res.superAdmin
          }else{
            res.admin = res.admin.concat(res.superAdmin)
          }
      }
      if(res.normal!=null){
          res.admin = res.admin.concat(res.normal)
      }
      this.tableData =res.admin;
      this.peopleCounting = this.tableData.length;
  },
    canleAdd(){
      this.inputPhone = "";
      this.inputName = "";
      this.code = "";
      this.NewDialogBox = false;
    },
  newCustomer(){//新增保存
      //判断验证码是否为空
      let code = this.code;
      if (code == '' || code == undefined) {
        this.$message.error('请输入验证码!');
        return;
      }
	  //信息校验，判断姓名，手机号是否为空
	  let name = this.inputName
	  if(name == '' || name == undefined){
	  	this.$message.error('姓名不能为空!');
	  	return;
	  }
    //判定输入手机号是否正确
    let value = this.inputPhone;
      if (value == '' || value == undefined) {
        this.$message.error('请输入正确的手机号!');
        return;
      }else {
        const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if ((!reg.test(value)) && value != '') {
          this.$message.error('请输入正确的手机号!');
          return;
        }
      }
      this.addNewContact(this.inputName,this.inputPhone,this.code);
      //  this.$message({
      //     message: '新增成功',
      //     type: 'success',
      //     // duration:0
      // });
  },
  async addNewContact(inputName,inputPhone,code){
      let res = await api.addNewContact(inputName,inputPhone,code);
      if(res == "新增成功!"){
        this.NewDialogBox = false;
        this.inputPhone = "";
        this.inputName = "";
        this.code = "";
        this.queryContactByCustomer();
        this.$message({
          message: res,
          type: 'success'
        });
      }else {
        this.$message.error(res);
      }

  },
        //根据当前人角色，判定功能权限
  initAuthByRole(){
    let role = window.localStorage.getItem("role");
    if(role == "超级管理员"){
      this.toEditDisabled = false;
      this.toEditNameDisabled = false;
	  this.toEditEmailDisabled = false;
    }else if(role == "管理员"){
      this.toEditDisabled = true;
      this.toEditNameDisabled = false;
	  this.toEditEmailDisabled = true;
    }else {
      this.toEditNameDisabled = true;
      this.toEditDisabled = true;
	  this.toEditEmailDisabled = true;
    }
  },
        //修改信息
  async editContact(){
    let customerCode = window.localStorage.getItem("customerCode");
	//信息校验，判断姓名，手机号是否为空
	let name = this.info.name
	if(name == '' || name == undefined){
		this.$message.error('姓名不能为空!');
		return;
	}
	//判定输入手机号是否正确
	let value = this.info.phone;
	  if (value == '' || value == undefined) {
	    this.$message.error('请输入正确的手机号!');
	    return;
	  }else {
	    const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
	    if ((!reg.test(value)) && value != '') {
	      this.$message.error('请输入正确的手机号!');
	      return;
	    }
	  }
    let param = {};
    if(this.amendFrameName == "手机号修改"){
      param ={
        linkMan: this.info.name,
        customerCode:customerCode,
        phoneNumber:this.info.phone,
        id:this.info.id
      }
    }else {
      param ={
        linkMan: this.info.name,
        customerCode:customerCode,
        phoneNumber:this.info.phone,
        id:this.info.id,
        email:this.info.email
      }
    }
    let res = await api.updateContactInfo(param);
    if("修改成功" == res){
      this.$message({
        message: '修改成功',
        type: 'success'
      });
      this.queryContactByCustomer();
      this.editPhoneDisabled = true;
      this.editPhoneDisabled = true;
      this.EditDialog = false
    }else {
      this.$message.error(res);

    }
  },

  clearCimer(){ //清除获取验证码定时器
      clearInterval(this.timer)
      this.getCodeStatus = false
      this.downCount='获取验证码'
  },
  cancel(){ // 取消暂停定时器
      this.phoneCode = ""
      this.mailboxCode = ""
      this.errorMsg = ""
      this.ModifydialogBox = false
  },
  amend(name){ //手机号修改/邮箱修改 弹框
      this.amendFrameName = name
      if(this.amendFrameName == "手机号修改"){
        this.ModifydialogBox = true
      }else {
        if( typeof this.info.email === 'undefined' || this.info.email == "" ){
          //不需要验证码，直接修改
          this.editEmailDisabled = false;
        }else {
          this.ModifydialogBox = true
        }
      }
  },
  getCode(){ // 获取验证码
      this.downCount = 50
      this.getCodeStatus = true
      this.timer = setInterval(()=>{
          this.downCount = this.downCount - 1
      if(this.downCount == 0)return this.clearCimer()
  },1000)
    if(this.NewDialogBox == true){
      //新增获取验证码
      //获取验证码
      let inputPhone = this.inputPhone;
      this.getVerificationCode(inputPhone);
    }else {
      //修改获取验证码
      if(this.amendFrameName == "手机号修改"){
        //获取验证码
        let inputPhone = this.info.phone;
        this.getVerificationCode(inputPhone);
      }else {
        //邮箱验证码
        this.getEmailVerificationCode();
      }
    }
  },
  async getVerificationCode(inputPhone){
      await api.getVerificationCode(inputPhone).then((res) => {
        if(res == "获取验证码成功"){
          this.$message({
            message: res,
            type: 'success'
          });
        }else {
          //获取失败
          this.clearCimer()
          this.$message(res);
        }
      })
  },
  //邮箱验证码
  async getEmailVerificationCode(){
      let inputEmail = this.info.email
      await api.getEmailVerificationCode(inputEmail).then((res) => {
        if(res == "获取验证码成功"){
          this.$message({
            message: res,
            type: 'success'
          });
        }else {
          this.clearCimer()
          this.$message(res);
        }
      })

  },
  async verifyVerificationCode(){
    let type = "P"
    let verCode = "";
    if(this.amendFrameName == "手机号修改"){
      if(this.phoneCode == ''){
        this.$message.error('请输入验证码!');
        return ;
      }
      type = "P"
      verCode = this.phoneCode
    }else {
      if(this.mailboxCode == ''){
        this.$message.error('请输入验证码!');
        return ;
      }
      type = "E"
      verCode = this.mailboxCode
    }
    let param = {
      type:type,
      verCode:verCode,
      email:this.info.email,
      phoneNumber:this.info.phone
    }
    console.info(param)

    // //跳过验证码验证，直接进入下一步
    // if(this.amendFrameName == "手机号修改"){
    //   this.editPhoneDisabled = false;
    // }else {
    //   this.editEmailDisabled = false;
    // }
    // this.ModifydialogBox = false;
    await api.checkVerCode(param).catch(function(error){
      console.info(error);
    }).then(res => {
		if(res === '验证码校验成功'){
		  //验证码正确，可以进行下一步
		  this.ModifydialogBox = false;
		  this.errorMsg = "";
		  if(this.amendFrameName == "手机号修改"){
		    this.editPhoneDisabled = false;
		  }else {
		    this.editEmailDisabled = false;
		  }
		  this.mailboxCode = ''
		}else {
		  //验证码错误
		  this.errorMsg = "验证码不正确"
		
		}
	});
  },
  dialogBox(name,item){ //编辑或新增弹框
      this.functionName = name
      if(name == '新增成员'){ //新增
          this.NewDialogBox = true
          console.log(name);
      } else if (name == '资料修改') { //编辑
          console.log(name,item);
          this.info.id = item.id;
          this.info.phone = item.phone;
          this.info.name = item.name;
          this.info.email = item.email;
          this.editPhoneDisabled = true;
          this.editEmailDisabled = true;
		  //如果是当前登录人可修改自己的邮箱
		  let loginPhoneNum = window.localStorage.getItem("realPhoneNum");
		  if(loginPhoneNum == item.phone ){
		  	  this.toEditEmailDisabled = false;
		  }else{
		  			  //修改信息非当前登录人时，判断是否是超级管理员，超管可修改所有人，其他的不能修改
		  			  let role = window.localStorage.getItem("role");
		  			  if(role == "超级管理员"){
		  				  this.toEditEmailDisabled = false;
		  			  }else{
		  				   this.toEditEmailDisabled = true;
		  			  }
		  			  
		  }
		  this.EditDialog = true;
      }else if (name == '删除'){ //删除
          this.deleteContactInfo(item.id);
      }

  },
  async deleteContactInfo(id){
    this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      api.deleteContactInfo(id).then(res => {
        console.info(res);
        this.$message({
          type: 'success',
          message: "删除联系人成功"
        });
        this.queryContactByCustomer();
      });
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      });
    });
  },
  cancelEdit(){
      this.EditDialog = false;
      this.editPhoneDisabled = true;
      this.editEmailDisabled = true;
      this.queryContactByCustomer();
  },
  nameReg(){
	   const value = this.info.name;
	   if (value == '' || value == undefined) {
	     this.$message.error('姓名不能为空!');
	   }
  },
  isEmailReg() {
    const value = this.info.email;
    const reg =  /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
    if (value == '' || value == undefined) {
      this.$message.error('邮箱地址不能为空!');
    } else {
      if (!reg.test(value)) {
        this.$message.error('请输入正确的邮箱地址!');
      }
	  if(value.includes("@deppon.com")){
		  this.$message.error('不能维护德邦内部邮箱!');
	  }
    }
  },
  isPhone(value) {
    const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
    if (value == '' || value == undefined) {
      this.$message.error('手机号不能为空!');
    } else {
      if ((!reg.test(value)) && value != '') {
        this.$message.error('请输入正确的手机号!');
      }
    }
  }
  }

  }
</script>

<style lang='less' scoped>
  .accountManagement{
    width: 100%;
    height: 100%;
    /deep/.el-button--small, .el-button--small.is-round span {
      color: #000;
    }
    /deep/.row .el-button {
      padding: 0;
    }
    .new-customer {
      text-align: left;
      padding-left: 32px;
      .peopleCounting{
        padding-left: 24px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }

    }
    .list {
      width: 100%;
      padding: 24px 32px;
      .vertical-bar {
        margin-top: 8px;
        width: 13px;
        height: 20px;
        font-size: 14px;
        color: #D6D6D6;
        line-height: 20px;
      }
    }
    .strong-frame {
      margin-top: -20px;
      margin-bottom: -10px;
      .row {
        margin-top: 24px;
        display: flex;
        align-items:center;
      }
      .amend {
        display: flex;
        margin-left: 8px;
      }
      .input {
        width: 205px;
      }
      .code-input {
        width: 87px;
      }
      .get-code {
        width: 102px;
        height: 32px;
        margin-left: 16px;
      }
      .error {
        font-size: 12px;
        color: #F95355;
        margin-left: 12px;
      }
    }

  }
</style>